import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
}), 'ExpandMoreSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExpandMoreSharp.js
// module id = 3446
// module chunks = 2